import React, { FC } from 'react';
import { Colors } from '../../../../styles/colors';

interface Props {
  color: string;
}

export const ProductIconPhone: FC<Props> = ({ color = Colors.white }) => {
  return (
    <svg id="Ebene_1" data-name="Ebene 1" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 36.99 73.12" style={{ color }}>
      <path id="Vereinigungsmenge_24" data-name="Vereinigungsmenge 24"
            d="M5.37,73.29A5.25,5.25,0,0,1,.17,68V5.47A5.25,5.25,0,0,1,5.37.17H32a5.25,5.25,0,0,1,5.2,5.3V68a5.25,5.25,0,0,1-5.2,5.3Zm-3-67.82V68a3,3,0,0,0,3,3H32a3,3,0,0,0,3-3h0V5.47a3,3,0,0,0-3-3H27.37V3a2.13,2.13,0,0,1-2.11,2.15H12.53A2.13,2.13,0,0,1,10.42,3h0V2.46h-5a3,3,0,0,0-3,3Z"
            transform="translate(-0.17 -0.17)" fill="currentColor" />
    </svg>
  );
};
